// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDER_KBpBHV0v1HllWne7xISsnqTkoGi_4",
  authDomain: "eabl-system-6fe33.firebaseapp.com",
  projectId: "eabl-system-6fe33",
  storageBucket: "eabl-system-6fe33.firebasestorage.app",
  messagingSenderId: "577258328497",
  appId: "1:577258328497:web:1d12e588be1ed92748ad90"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);

export default app;
